import React, { createContext, useState, useEffect, useContext } from 'react';

const FavoritesContext = createContext();

export const useFavorites = () => useContext(FavoritesContext);

export const FavoritesProvider = ({ children }) => {
    const [favorites, setFavorites] = useState(() => {
        // Load from local storage on initial render
        const savedFavorites = localStorage.getItem('favorites');
        return savedFavorites ? JSON.parse(savedFavorites) : [];
    });

    const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);

    useEffect(() => {
        // Save to local storage whenever favorites changes
        localStorage.setItem('favorites', JSON.stringify(favorites));
    }, [favorites]);

    const toggleFavorite = (product) => {
        setFavorites((prevItems) => {
            const exists = prevItems.find((item) => item.id === product.id);
            if (exists) {
                return prevItems.filter((item) => item.id !== product.id);
            }
            return [...prevItems, product];
        });
        // Optional: Open sidebar when adding? maybe just a notification is better, 
        // but user asked for "like cart model", so let's stick to simple logic first.
        // If we want to mimic cart strictly: we might open it. 
        // But usually heart toggle is silent. I'll leave it silent but notify nicely via UI state.
        if (!favorites.find(item => item.id === product.id)) {
            setIsFavoritesOpen(true);
        }
    };

    const removeFavorite = (productId) => {
        setFavorites((prevItems) => prevItems.filter((item) => item.id !== productId));
    };

    const clearFavorites = () => {
        setFavorites([]);
    };

    const isFavorite = (productId) => {
        return favorites.some(item => item.id === productId);
    };

    return (
        <FavoritesContext.Provider
            value={{
                favorites,
                toggleFavorite,
                removeFavorite,
                clearFavorites,
                isFavorite,
                isFavoritesOpen,
                setIsFavoritesOpen
            }}
        >
            {children}
        </FavoritesContext.Provider>
    );
};
